<template>
    <div class="table-list">
        <div>
            <ul class="table hd">
                <li class="table-row">
                    <div class="table-row__cell type">问题类型</div>
                    <div class="table-row__cell rank">问题等级</div>
                    <div class="table-row__cell content">问题内容</div>
                    <div class="table-row__cell time">发起时间</div>
                    <div class="table-row__cell data">逾期天数</div>
                </li>
            </ul>
        </div>
        <vue-seamless-scroll class="recordlist"
            v-if="data && data.length"
            :data="data"
            :class-option="classOption">
            <ul  class="table">
                <li class="table-row" v-for="item in data" :key="item.id">
                    <div class="table-row__cell type">{{item.problemTypeName}}</div>
                    <div class="table-row__cell rank">{{item.problemLevel}}</div>
                    <div class="table-row__cell content">{{item.content}}</div>
                    <div class="table-row__cell time">{{item.createTime}}</div>
                    <div class="table-row__cell data">{{item.daysOverdue}}</div>
                </li>
            </ul>
        </vue-seamless-scroll>
        <div v-else class="empty">
            暂无数据
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            default () {
                return []
            }
        }
    },
    data () {
        return {
            classOption: {
                singleHeight: 44,
            }
        }
    }
}
</script>

<style lang="less" scoped>
.recordlist {
    height: 264px;
    overflow: hidden;
}
.empty {
    font-size: 16px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 255px;
    text-align: center;
}
.table-list {
    margin-top: 16px;
}
.table {
    font-size: 12px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #40D5FF;
    .table-row {
        display: flex;
        height: 44px;
        align-items: center;
        background: rgba(7, 51, 72, 1);
        padding: 0 12px;
        &:nth-child(odd) {
            background: rgba(6, 41, 57, 1);
        }
        &__cell {
            white-space: nowrap;
            overflow: hidden;
            flex: none;
            &.type {
                width: 80px;
            }
            &.rank {
                width: 48px;
                padding-left: 24px;
            }
            &.content {
                width: 442px;
                padding-left: 24px;
            }
            &.time {
                width: 126px;
                padding-left: 24px;
            }
            &.data {
                width: 88px;
                padding-left: 24px;
            }
        }
    }
    &.hd {
        .table-row {
            background: rgba(7, 51, 72, 1)!important;
            color: #fff;
        }
    }
}
</style>